import Vue from 'vue';
import { DataStore } from "aws-amplify";

// Create a simple event bus (if you already have a global event bus, reuse it instead)
const EventBus = new Vue();

// Export a function that can be imported and called from anywhere in your app
export const showErrorSnackbar = () => {
  EventBus.$emit('show-error-snackbar');
};

export default {
  data() {
    return {
      showError: false,
    };
  },
  created() {
    // Listen for the event to show the snackbar
    EventBus.$on('show-error-snackbar', () => {
      this.showError = true;
    });
  },
  methods: {
    async resetAndRefresh() {
      localStorage.clear();
       await DataStore.stop();
       await DataStore.clear();
              
      location.reload();
    },
  },
};